module.exports = __webpack_public_path__ + "static/media/espacamento2.630d2377.png";